import React from "react";
import {
	Container,
	Row,
	Col,
	Card,
	Button,
	Badge,
	ListGroup,
} from "react-bootstrap";
import { FaGlobe } from "react-icons/fa";

const AboutUs = () => {
	return (
		<Container>
			<h1 className="text-start mt-4 mb-4 text-info fw-bold">ABOUT US</h1>

			<Card className="shadow mb-4 bg-dark text-white">
				<Card.Body>
					<Card.Text className="mb-4">
						This platform is dedicated to providing the best fantasy experience
						for mountain bike fans. Ultimately, the goal is to have a platform
						incorperating all series and disciplines within mountain biking.
						Slopestyle, Rampage, Dowhnill, Hardline, Cross Country with the UCI,
						Crankworx, Red Bull - it's all on the radar. We are a small but
						passionate team of riders looking to follow all aspects of the
						sport. We are constantly looking to improve the platform and add new
						features to enhance the user experience. We are open to feedback and
						suggestions from our users, so please feel free to reach out to us
						with any ideas or comments.
					</Card.Text>

					<Card.Title className="border-bottom pb-2">
						<Badge bg="secondary" className="me-2">
							Team
						</Badge>
						Meet Our Team
					</Card.Title>

					<Row className="mt-4">
						<Col md={4} className="mb-4">
							<Card className="h-100 shadow-sm bg-dark text-white">
								<Card.Body>
									<Card.Title className="fw-bold">Kurtis Gassewitz</Card.Title>
									<Card.Subtitle className="mb-2 text-info">
										Founder & Developer
									</Card.Subtitle>
									<Card.Text>
										A passionate biker and skier living in Squamish, British
										Columbia. Started DownhillMTBFantasy as a project while
										recovering from an illness and has been working to create
										the ultimate fantasy platform for mountain biking fans.
									</Card.Text>
								</Card.Body>
							</Card>
						</Col>

						<Col md={4} className="mb-4">
							<Card className="h-100 shadow-sm bg-dark text-white">
								<Card.Body>
									<Card.Title className="fw-bold">Davi Birks</Card.Title>
									<Card.Subtitle className="mb-2 text-info">
										Co-Founder & Content Creator
									</Card.Subtitle>
									<Card.Text>
										A podcaster with The Ride Companion living in the UK. Brings
										extensive knowledge of the mountain biking scene and helps
										create engaging content for the platform through his
										connection with the professional circuit.
									</Card.Text>
									<Button
										size="sm"
										variant="outline-info"
										href="http://theridecompanion.co.uk"
										target="_blank"
										rel="noopener noreferrer"
									>
										<FaGlobe className="me-1" /> The Ride Companion
									</Button>
								</Card.Body>
							</Card>
						</Col>

						<Col md={4} className="mb-4">
							<Card className="h-100 shadow-sm bg-dark text-white">
								<Card.Body>
									<Card.Title className="fw-bold">Adam Dayson</Card.Title>
									<Card.Subtitle className="mb-2 text-info">
										Co-Founder & Marketing Specialist
									</Card.Subtitle>
									<Card.Text>
										A dedicated biker and marketing expert living in the UK.
										Helps grow the platform's reach and develops strategies to
										engage with the mountain biking community while ensuring the
										best user experience.
									</Card.Text>
								</Card.Body>
							</Card>
						</Col>
					</Row>
				</Card.Body>
			</Card>
		</Container>
	);
};

export default AboutUs;
